import React from 'react';
import WidthHeight from './WidthHeight';
import BorderRadius from './BorderRadius';

const SkeletonComponent = () => {
  return (
    <div className="m-3">
      <h3>Skeletons</h3>
      <p>Skeletons can be used as a preview for your content before data gets loaded.</p>
      <WidthHeight />
      <BorderRadius />
    </div>
  );
};

export default SkeletonComponent;
